<template>
  <el-row class="content">
      <el-col :span="5" class="record-left">
        <div style="margin-top: .2rem">
          <el-avatar :size="40" :src="sex=='男'?'static/img/huanzhenan.png':'static/img/huanzhenv.png'"></el-avatar>
        </div>
        <div style="color: #888888;font-size: .26rem">{{name}}</div>
      </el-col>
      <el-col :span="19" style="height: 100%;">
        <div class="doctor-desc">{{registration}}&nbsp{{doctorName}}</div>
        <div class="record-date">{{date}}&nbsp{{dateDuan}}</div>
        <el-row class="record-price">
          <el-col :span="15" style="color: #e6a23c">￥{{price}}</el-col>
          <el-col :span="8" class="record-price-status" v-if="!status" :style="type==0?'':'color:#32CD32'">{{type==0?'未支付':'已支付'}}</el-col>
          <el-col :span="8" class="record-price-status" v-if="status" style="color: red">已取消</el-col>
        </el-row>
      </el-col>
    </el-row>
</template>

<script>
    export default {
      props:{
        //性别
        sex:{
          type:String
        },
        //名字
        name:{
          type:String,
        },
        //门诊名称
        registration:{
          type:String,
        },
        //医生名字
        doctorName:{
          type:String,
        },
        //预约时间
        date:{
          type:String,
        },
        //预约时间
        dateDuan:{
          type:String,
        },
        //价格
        price:{
          type:String,
        },
        //交易类型
        type:{
          type:Number,
        },
        //是否取消
        status:{
          type:Boolean
        }
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 1.6rem;
    background-color: #ffffff;
    border-bottom: 1px #dddddd solid;
  }
  .record-left{
    height: 100%;
    text-align: center;
  }
  .doctor-desc{
    font-size: .28rem;
    height: .5rem;
    line-height: .7rem;
    margin-top: .04rem;
  }
  .record-date{
    font-size: .26rem;
    height: .5rem;
    line-height: .6rem;
    color: #999999;
  }
  .record-price{
    font-size: .28rem;
    height: .4rem;
    line-height: .5rem;
    color: #999999;
  }
  .record-price-status{
    text-align: right;
    font-size: .24rem
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Record.vue